import { withCompInfo } from '../../core/withCompInfo'
import { SlideShowSlideDefinition, SlideShowSlideProps, SlideShowSlideCSSVars, SlideShowSlideSdkData } from './types'
import { SlideShowSlideCarmiData, SlideShowSlideCSSCarmiData } from '../..'

export const props = withCompInfo<SlideShowSlideProps, SlideShowSlideDefinition, SlideShowSlideCarmiData>(
	[],
	(deps, carmiProps) => {
		return { fillLayers: carmiProps.fillLayers, meshProps: carmiProps.meshProps }
	}
)

export const css = withCompInfo<SlideShowSlideCSSVars, SlideShowSlideDefinition, SlideShowSlideCSSCarmiData>(
	[],
	(deps, cssVars) => ({
		position: 'absolute',
		width: '100%',
		height: '100%',
		...cssVars,
	})
)

export const sdkData = withCompInfo<SlideShowSlideSdkData, SlideShowSlideDefinition>(['compData'], ({ compData }) => ({
	name: compData.title,
}))
